<template>
    <div>
        <h1>Comunidade</h1>
        <p>Entre na nossa comunidade no discord</p><a href="https://discord.gg/wwpf2jUK">https://discord.gg/wwpf2jUK</a>
    </div>
</template>
<script>
export default {
    name: "Comunidade"
}
</script>